import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../various/Heading';
import { Reload } from '../various/Icons';

export const SomethingWentWrong = () => {
  const { t } = useTranslation(['common', 'genericErrors']);
  const [isAnimate, setIsAnimate] = React.useState(false);

  const reloadHandler = React.useCallback(() => {
    location.reload();
    setIsAnimate(true);
  }, []);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center text-center">
      <Heading title={t('common:something_went_wrong')} variant={['big', 'black']} />
      <button className="flex cursor-pointer items-center gap-2" onClick={reloadHandler}>
        <Reload className={cx({ 'animate-spin': isAnimate })} />
        <span className="inline-block body-1">{t('genericErrors:refresh_page')}</span>
      </button>
    </div>
  );
};
